import { render, staticRenderFns } from "./Roadcast.vue?vue&type=template&id=7a87e8f2&"
import script from "./Roadcast.vue?vue&type=script&lang=js&"
export * from "./Roadcast.vue?vue&type=script&lang=js&"
import style0 from "./Roadcast.vue?vue&type=style&index=0&id=7a87e8f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports